import { me, loggedIn } from './me'
import selectLogin from './login'
import selectSignup from './signup'
import selectResetPassword from './resetPassword'
import selectForgotPassword from './forgotPassword'

export const selectMe = me
export const selectLoggedIn = loggedIn
export { selectLogin, selectSignup, selectResetPassword, selectForgotPassword }

export default {
  selectMe,
  selectLoggedIn,
  selectLogin,
  selectSignup,
  selectResetPassword,
  selectForgotPassword,
}
